<div class="main-container">
  <div *ngIf="editEmployeeCompetenciesMode; else selectEmployee" class="d-flex flex-column h-100">
    <div class="labels">
      <div class="text-overflow-dotted">
        {{ editedEmployeeCompetency.employeeName }}
      </div>
    </div>
    <div class="search-bar pt-3 px-2">
      <input
        type="search"
        class="form-control"
        placeholder="{{ 'competency.search_competency' | translate }}"
        #searchInput
        data-testid="competency-search-input"
        [(ngModel)]="searchText"
        (input)="onSearchInput()"
      />
      <button
        *ngIf="!isForProjects && !editedEmployeeCompetency.displayOnly"
        class="btn primary-btn ms-2"
        (click)="openAssignCompetencyModal()"
      >
        {{ "competency.assign_competency" | translate }}
      </button>
    </div>
    <ng-container *ngIf="!errorFetchingCompetencies; else errorMessage">
      <div class="competency-container">
        <div class="full-height py-2 px-2">
          <div class="competency-list scrollable-list full-height">
            <div
              id="employee-competency-accordion"
              ngbAccordion
              #employeeCompetencyAccordion="ngbAccordion"
              class="w-100"
            >
              <div
                ngbAccordionItem="{{ type.name }}"
                *ngFor="let type of competencyGroups"
              >
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton>
                    <div class="category-header">
                      <div>
                        {{ type.name }}
                      </div>
                      <span
                        *ngIf="type.name == 'Language'"
                        ngbTooltip="{{
                          'competency.language_level_tooltip' | translate
                        }}"
                        placement="bottom"
                        container="body"
                        class="ms-1"
                        ><fa-icon [icon]="['fas', 'circle-info']"></fa-icon
                      ></span>
                      <div class="ms-auto me-4">
                        {{
                          getCompetenciesInCategoryFromArray(
                            filteredEmployeeCompetencies,
                            type.id
                          ).length
                        }}
                      </div>
                    </div>
                  </button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <div>
                        <div
                          class="competency-item"
                          *ngFor="
                            let competency of getCompetenciesInCategoryFromArray(
                              filteredEmployeeCompetencies,
                              type.id
                            )
                          "
                        >
                          <div class="d-flex flex-row align-items-center w-100">
                            <span
                              class="text-overflow-dotted competency-name"
                              >{{ competency.competency.name }}</span
                            >
                            <ng-container
                              *ngIf="
                                competency.competency.id !==
                                  levelEditedEmployeeCompetency?.id;
                                else levelEditMode
                              "
                            >
                              <span class="ms-auto competency-level">
                                <label>
                                  {{ competency.level }}
                                </label>
                                <fa-icon
                                  *ngIf="
                                    !isForProjects &&
                                    !editedEmployeeCompetency.displayOnly
                                  "
                                  (click)="
                                    onStartEditingLevel(competency.competency)
                                  "
                                  class="edit-level-icon ms-3"
                                  [icon]="['fas', 'pen']"
                                ></fa-icon>
                              </span>
                              <fa-icon
                                *ngIf="
                                  !isForProjects &&
                                  !editedEmployeeCompetency.displayOnly &&
                                  competency.competency.id !==
                                    levelEditedEmployeeCompetency?.id
                                "
                                class="add-remove-icon ms-3"
                                [icon]="['fas', 'trash']"
                                (click)="deleteEditedCompetency(competency)"
                              ></fa-icon>
                            </ng-container>
                            <ng-template #levelEditMode>
                              <span class="ms-auto competency-level">
                                <select
                                  class="level-input-box"
                                  [(ngModel)]="
                                    levelEditedEmployeeCompetency!.level
                                  "
                                >
                                  <option
                                    *ngFor="
                                      let competency of employeeCompetencyLevelService.getOptions()
                                    "
                                  >
                                    {{ competency }}
                                  </option>
                                </select>                                
                              </span>
                              <fa-icon
                                  class="edit-level-icon ms-3"
                                  [icon]="['fas', 'save']"
                                  (click)="onSaveLevelEditing()"
                                ></fa-icon>
                                <fa-icon
                                  class="edit-level-icon ms-3"
                                  [icon]="['fas', 'xmark']"
                                  (click)="onCancelLevelEditing()"
                                ></fa-icon>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #errorMessage>
      <div class="error-message pt-5 px-3">
        {{ "competency.errorFetchingCompetencies" | translate }}
      </div>
    </ng-template>
  </div>
  <ng-template #selectEmployee>
    <div class="error-message pt-5 px-3">
      {{ "competency.select_employee" | translate }}
    </div>
  </ng-template>
</div>
